import React from 'react';
import { Link } from 'react-router-dom';
import dashboardService from '../../services/dashboardService';
import { ROUTES } from '../../constants/routes';

const DashboardTopMerchants = ({ topMerchants = [] }) => {
  return (
    <div className='bg-white rounded-xl border border-gray-200 shadow-xs p-5'>
      <div className='flex items-center justify-between mb-4'>
        <div>
          <h3 className='text-base font-bold text-gray-900'>Top 5 Performing Merchants</h3>
          <p className='text-xs text-gray-500'>Highest transaction volume drivers across the platform</p>
        </div>
        <Link
          to={ROUTES.MERCHANTS}
          className='text-xs font-semibold text-blue-600 hover:text-blue-800'
        >
          View all merchants →
        </Link>
      </div>

      {topMerchants.length === 0 ? (
        <div className='text-center py-8 text-xs text-gray-400'>
          No transaction volume recorded for this period.
        </div>
      ) : (
        <div className='overflow-x-auto'>
          <table className='min-w-full divide-y divide-gray-200 text-xs'>
            <thead>
              <tr className='text-left text-gray-400 uppercase tracking-wider font-semibold'>
                <th className='pb-3 w-10'>#</th>
                <th className='pb-3'>Merchant</th>
                <th className='pb-3 text-right'>Volume</th>
                <th className='pb-3 text-center'>Transactions</th>
                <th className='pb-3 text-right'>Marketing Balance</th>
              </tr>
            </thead>
            <tbody className='divide-y divide-gray-100 font-medium'>
              {topMerchants.map((m, idx) => (
                <tr key={m.companyId || idx} className='hover:bg-gray-50 transition-colors'>
                  <td className='py-3 text-gray-400 font-bold'>
                    {idx === 0 ? (
                      <span className='inline-flex items-center justify-center w-5 h-5 rounded-full bg-amber-100 text-amber-800 text-2xs font-extrabold'>
                        1
                      </span>
                    ) : idx === 1 ? (
                      <span className='inline-flex items-center justify-center w-5 h-5 rounded-full bg-slate-200 text-slate-700 text-2xs font-extrabold'>
                        2
                      </span>
                    ) : idx === 2 ? (
                      <span className='inline-flex items-center justify-center w-5 h-5 rounded-full bg-amber-700/20 text-amber-900 text-2xs font-extrabold'>
                        3
                      </span>
                    ) : (
                      idx + 1
                    )}
                  </td>
                  <td className='py-3 text-gray-900 font-semibold'>
                    <Link
                      to={`/merchants/${m.companyId}`}
                      className='hover:text-blue-600 hover:underline transition-colors'
                    >
                      {m.companyName || 'Unknown Merchant'}
                    </Link>
                  </td>
                  <td className='py-3 text-right font-bold text-gray-900'>
                    {dashboardService.formatCurrency(m.volume)}
                  </td>
                  <td className='py-3 text-center text-gray-600'>
                    {dashboardService.formatNumber(m.transactionCount)}
                  </td>
                  <td className='py-3 text-right text-emerald-600 font-semibold'>
                    {dashboardService.formatCurrency(m.marketingBalance || 0)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DashboardTopMerchants;
